export const isLite = () => {
  return !!process.env.REACT_APP_IS_LITE
}
